import React from "react"

import { useHistory } from "react-router-dom";
import useSWR from 'swr';
import { Button, Card } from "../ui";
import AuthService from '../services/authentication'
import { useOrder, updateLineItem, sendOrder } from '../data/order';

function OrderSummary() {
  let history = useHistory();
  const auth = AuthService.useAuth();
  const { order, mutate, isLoading, isError } = useOrder(auth.authHeader());

  const hasItems = () => {
    return [...order.product_line_items, ...order.mixture_line_items].length !== 0
  }

  if(isLoading) return <div>Loading...</div>;
  if(isError) return <div>Error occurred!</div>;

  const renderLineItems = () => {
    return [...order.product_line_items, ...order.mixture_line_items].map((lineItem, i) => (
      <li key={lineItem.id} className="py-2 mt-3">
        <div>
          <p className="w-full">{lineItem.mixture ? 'Custom herbal formulation' : lineItem.name}</p>
        </div>
      </li>
    ));
  }

  return (
    <Card>
      <div className="border-b border-gray-200 px-4 py-3 font-medium">Prescribed Products List</div>
      <ul className="divide-y divide-gray-200 px-4">
        {hasItems() ? renderLineItems() : <span className="text-gray-500 py-2 ms-3">No products</span>}
      </ul>
      <Card.Body>
        <Button variant="primary" onClick={() => history.push('/order')} disabled={!hasItems()}>Add Details</Button>
      </Card.Body>
    </Card>
  )
}

export default OrderSummary;
